import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02490b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite-friend__textarea" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import ModalWrapper from "@/components/modal-wrapper/index.vue";
import CopyIcon from "@/icons/common/copy-icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const copy = () => {
  navigator.clipboard.writeText("https://www.mydotwallet.com");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalWrapper, { title: "Send invite to your friend" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" Hey! You should check out *Polkadapp*. It is an easy to use and secure Polkadot dapp with the most useful features."),
        _hoisted_2,
        _hoisted_3,
        _createTextVNode("www.mydotwallet.com "),
        _createElementVNode("a", {
          class: "invite-friend__copy",
          onClick: copy
        }, [
          _createVNode(CopyIcon)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})